/* MY01 | by marwanyousef.com */
(function () {
    if (customElements.get('my01-product')) return;


    class My01Product extends HTMLElement {
      connectedCallback() {
        try { this.str = JSON.parse(this.dataset.strings || '{}'); } catch (e) { this.str = {}; }
        this.product = JSON.parse(this.querySelector('[data-product-json]').textContent);
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('.my01-pd__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.status = this.querySelector('[data-status]');
        this.priceEl = this.querySelector('[data-price]');
        this.input = this.querySelector('[data-variant-input]');
        this.plus = this.querySelector('[data-plus]');
        this.addBtn = this.querySelector('[data-add]');
        this.optWrap = this.querySelector('[data-options-wrap]');
        this.index = 0;
        this.variant = null;

        this.initGallery();
        this.initBack();

        if (My01.hasOnlyDefault(this.product)) {
          this.variant = this.product.variants[0];
        } else if (this.optWrap) {
          var pre = null;
          var urlId = new URLSearchParams(location.search).get('variant');
          if (urlId) pre = this.product.variants.find((v) => String(v.id) === urlId) || null;
          this.picker = new My01.VariantButtons(this.querySelector('[data-options]'), this.product, {
            preselect: pre,
            onChange: (v) => this.onVariant(v, true),
            swatches: this.dataset.swatches === 'true'
          });
          this.variant = this.picker.variant();
          if (this.variant) this.onVariant(this.variant, false);
        }

        if (this.plus) this.plus.addEventListener('click', () => this.onPlus());
        if (this.addBtn) this.addBtn.addEventListener('click', () => this.add());
        var form = this.querySelector('.my01-pd__form');
        if (form) form.addEventListener('submit', (e) => { e.preventDefault(); this.add(); });
      }

      /* ---------- Gallery ---------- */
      initGallery() {
        if (!this.track) return;
        if (this.prev) this.prev.addEventListener('click', () => this.go(this.index - 1));
        if (this.next) this.next.addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((d) => d.addEventListener('click', () => this.go(parseInt(d.dataset.dot, 10))));
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
        });
        var t;
        this.track.addEventListener('scroll', () => {
          clearTimeout(t);
          t = setTimeout(() => {
            var w = this.track.clientWidth || 1;
            this.setIndex(Math.round(this.track.scrollLeft / w));
          }, 60);
        }, { passive: true });
        this.setIndex(0);
      }

      go(i) {
        var n = this.slides.length;
        if (!n) return;
        i = this.dataset.loop === 'true' ? (i + n) % n : Math.max(0, Math.min(n - 1, i));
        this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
        this.setIndex(i);
      }

      setIndex(i) {
        this.index = i;
        this.dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
        this.slides.forEach((sl, k) => { if (k === i) sl.removeAttribute('aria-hidden'); else sl.setAttribute('aria-hidden', 'true'); });
        if (this.dataset.loop !== 'true') {
          if (this.prev) this.prev.disabled = i <= 0;
          if (this.next) this.next.disabled = i >= this.slides.length - 1;
        }
      }

      initBack() {
        var back = this.querySelector('[data-back]');
        if (!back) return;
        back.addEventListener('click', (e) => {
          if (document.referrer && document.referrer.indexOf(location.host) > -1 && history.length > 1) {
            e.preventDefault();
            history.back();
          }
        });
      }

      /* ---------- Variants ---------- */
      onVariant(v, fromUser) {
        this.variant = v;
        this.status.textContent = '';
        if (!v) { if (this.addBtn) this.addBtn.disabled = false; return; }
        this.input.value = v.id;
        if (this.priceEl) {
          this.priceEl.innerHTML = (v.compare_at_price > v.price ? '<s>' + My01.formatMoney(v.compare_at_price) + '</s>' : '') + My01.formatMoney(v.price);
        }
        if (this.addBtn) {
          this.addBtn.disabled = !v.available;
          this.addBtn.textContent = v.available ? this.str.add : this.str.soldOut;
        }
        if (v.featured_media) {
          var idx = this.slides.findIndex((sl) => sl.dataset.mediaId === String(v.featured_media.id));
          if (idx > -1 && fromUser) this.go(idx);
        }
        if (this.dataset.updateUrl === 'true' && fromUser) {
          var url = new URL(location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
        if (fromUser && v.available && this.dataset.autoAdd === 'true' && this.dataset.mode === 'reveal') this.add();
      }

      onPlus() {
        if (!this.optWrap || this.dataset.mode !== 'reveal') { this.add(); return; }
        var open = !this.optWrap.classList.contains('is-open');
        this.toggleOptions(open);
      }

      toggleOptions(open) {
        if (!this.optWrap) return;
        this.optWrap.classList.toggle('is-open', open);
        if (this.plus && this.dataset.mode === 'reveal') {
          this.plus.classList.toggle('is-open', open);
          this.plus.setAttribute('aria-expanded', open);
        }
        if (this.addBtn && this.dataset.mode === 'reveal') this.addBtn.hidden = !open;
        if (open) {
          var first = this.optWrap.querySelector('.my01-opt__btn:not(.is-unavailable)');
          if (first) setTimeout(() => first.focus(), 50);
        }
      }

      add() {
        var v = this.variant;
        if (!v) {
          this.status.textContent = this.str.choose;
          this.toggleOptions(true);
          return;
        }
        if (!v.available) { this.status.textContent = this.str.soldOut; return; }
        var btn = this.addBtn && !this.addBtn.hidden ? this.addBtn : this.plus;
        if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
        My01.addToCart({ id: v.id, quantity: 1 })
          .then(() => {
            this.status.textContent = this.str.added;
            if (this.dataset.mode === 'reveal') this.toggleOptions(false);
            setTimeout(() => { this.status.textContent = ''; }, 2500);
          })
          .catch((err) => { if (err.message !== 'busy') this.status.textContent = err.message; })
          .finally(() => { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
      }
    }

    customElements.define('my01-product', My01Product);
  })();
